import React from "react";
import Chart from "react-apexcharts";

const MixedChart = (props) => {
  const { series, categories } = props;
  const [chartOptions, setChartOptions] = React.useState({
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    tooltip: {
      theme: "dark",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          colors: "#A0AEC0",
          fontSize: "10px",
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#A0AEC0",
          fontSize: "10px",
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      borderColor: "#56577A",
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    fill: {
      type: "solid",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0.5,
        stops: [],
      },
      colors: ["#FC6009", "#83848A"],
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        columnWidth: "8px",
      },
    },
    colors: ["#FC6009", "#83848A"],
  });
  const [chartSeries, setChartSeries] = React.useState([
    {
      name: "",
      type: "bar",
      data: [],
    },
    {
      name: "",
      type: "line",
      data: [],
    },
  ]);
  React.useEffect(() => {
    if (categories && categories.length > 0) {
      setChartOptions({
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
          categories: categories,
        },
      });
    }
  }, [categories]);

  React.useEffect(() => {
    if (series && series.length > 0) {
      setChartSeries(series);
    }
  }, [series]);

  return <Chart options={chartOptions} series={chartSeries} type="line" width="100%" height="100%" />;
};

export default MixedChart;
